import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["backgroundColor", "open", "onCloseClick", "showCloseButton", "backButton", "children", "headerContent", "subheader", "marginTop", "overflow"];
import { createPortal } from 'react-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { LeftIcon } from 'foundations-assets/icons/components/LeftIcon';
import { RemoveIcon } from 'foundations-assets/icons/components/RemoveIcon';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Box } from 'foundations-components/transitional/components/Box';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import styled, { useTheme } from 'foundations-theming/utils';
import useDisableBodyScroll from '../../../hooks/useDisableBodyScroll';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const noop = () => {};
const OverlayContent = styled.div.withConfig({
  displayName: "FullScreenModal__OverlayContent"
})(["position:fixed;top:0;bottom:0;left:0;right:0;z-index:1111;background-color:", ";transition:", ";opacity:", ";transform:", ";pointer-events:", ";overflow:", ";margin-top:", ";"], ({
  overlayBackgroundColor
}) => overlayBackgroundColor, ({
  open
}) => open ? `transform 300ms ease-out` : `transform 300ms ease-out,
    opacity 0s 300ms`, ({
  open
}) => open ? '1' : '0', ({
  open
}) => open ? 'translateY(0%)' : 'translateY(100%)', ({
  open
}) => open ? 'auto' : 'none', ({
  overflow
}) => overflow || 'auto', ({
  marginTop
}) => marginTop);
const StickyHeaderWrapper = styled.div.withConfig({
  displayName: "FullScreenModal__StickyHeaderWrapper"
})(["position:sticky;top:0;z-index:1;width:100%;color:", ";"], props => props.theme.color['text-primary-default']);
const FullScreenModal = _ref => {
  let {
      backgroundColor = 'fill-surface-default',
      open = false,
      onCloseClick = noop,
      showCloseButton = true,
      backButton,
      children,
      headerContent,
      subheader,
      marginTop,
      overflow
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  useDisableBodyScroll(open);
  return /*#__PURE__*/createPortal(
  /*#__PURE__*/
  // @bend-expect trellis-tokenized
  _jsx(OverlayContent, Object.assign({
    "data-test-is-showing": open,
    marginTop: marginTop,
    open: open,
    overflow: overflow,
    overlayBackgroundColor: theme.color[backgroundColor]
  }, restProps, {
    children: /*#__PURE__*/_jsxs(Flex, {
      blockSize: "100%",
      flexDirection: "column",
      children: [/*#__PURE__*/_jsx(StickyHeaderWrapper, {
        children: headerContent && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(View, {
            backgroundColor: "do-not-use-pantera",
            paddingBlock: "300",
            paddingInline: "500",
            children: /*#__PURE__*/_jsxs(TFlex, {
              align: "center",
              children: [showCloseButton && /*#__PURE__*/_jsx(IconButton, {
                "data-test-id": "full-screen-modal-close",
                onClick: onCloseClick,
                placement: "right",
                use: "unstyled",
                children: backButton ? /*#__PURE__*/_jsxs("span", {
                  children: [/*#__PURE__*/_jsx(LeftIcon, {
                    color: "icon-core-on-fill-default"
                  }), /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "learningCenter.common.back"
                  })]
                }) : /*#__PURE__*/_jsx(RemoveIcon, {
                  color: "icon-core-on-fill-default"
                })
              }), headerContent]
            })
          }), subheader]
        })
      }), /*#__PURE__*/_jsx(Box, {
        grow: 1,
        inlineSize: "100%",
        children: children
      })]
    })
  })), document.body);
};
export default FullScreenModal;